<template>
    <div class="page-account" style="position: relative">
        <div style="z-index: 3" class="container containerBig">
            <div style="overflow: hidden" class="index_from page-account-container from-wh">
                <div class="page-account-top">
                    <div style="transform: scale(2)" class="page-account-top-logo">商户管理后台</div>
                </div>
                <!-- 添加登录选择方式 -->
                <RadioGroup v-model="loginMethod" type="button" button-style="solid">
                    <Radio label="账号登录"></Radio>
                    <Radio label="扫码登录"></Radio>
                </RadioGroup>
                <!-- 账号登录 -->
                <template v-if="loginMethod === '账号登录'">
                    <Form style="margin-top: 30px" ref="ref_login" :model="formInline" :rules="ruleInline">
                        <FormItem prop="username">
                            <Input type="text" v-model="formInline.username" prefix="ios-contact-outline" placeholder="请输入用户名" size="large" />
                        </FormItem>
                        <FormItem prop="password">
                            <Input
                                @on-enter="() => handleSubmitV5()"
                                autocomplete="new-password"
                                type="password"
                                v-model="formInline.password"
                                prefix="ios-lock-outline"
                                placeholder="请输入密码"
                                size="large"
                            />
                        </FormItem>
                        <FormItem prop="text">
                            <div style="display: flex; align-items: center">
                                <Input size="large" v-model="formInline.text" style="flex: 1" placeholder="请输入验证码" />
                                <div @click="getAuthPic" style="margin-left: 10px; cursor: pointer" v-html="authPic"></div>
                            </div>
                        </FormItem>
                        <FormItem>
                            <Button type="primary" long size="large" @click="handleSubmitV5()" class="btn">登录</Button>
                        </FormItem>
                    </Form>
                </template>
                <!-- 扫码登录 -->
                <template v-if="loginMethod === '扫码登录'">
                    <div style="margin-top: 10px">
                        <qrScanCode
                            :sceneType="{
                                login: loginScen,
                                auth: 'bing001',
                            }"
                            scene="login"
                        />
                    </div>
                </template>
            </div>
        </div>
        <Modal>
            <div class="captchaBox">
                <div id="captcha" style="position: relative" ref="captcha"></div>
            </div>
        </Modal>
        <Modal v-model="modalUnBindCheck" title="">
            <div>当时账号未绑定微信，安全系数较低，建议绑定</div>
            <div slot="footer" style="text-align: right">
                <Button @click="jumpBing">下次再说</Button>
                <Button @click="binding" type="primary" style="margin-left: 10px">去绑定</Button>
            </div>
        </Modal>
        <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: black; z-index: 1; opacity: 0.3"></div>
    </div>
</template>
<script>
import '../assets/js/canvas-nest.min';
import '../assets/js/jigsaw.js';
import { md5 } from '../assets/js/md5.js';
import { asdf, login, Set_mcode, GetImageCaptcha, LoginV5 } from '../request/api.js';
import qrScanCode from '@/components/qrScanCode.vue';
import { show_loading, hide_loading } from '../request/lib/common.js';

// const ScanQRCodeAuth = window.ScanQRCodeAuth.default || window.ScanQRCodeAuth;
// //console.log(ScanQRCodeAuth);
// // 创建新实例
// const createQrCode = (container) => {
//     const authInstance = new ScanQRCodeAuth({
//         appId: '68bbec5eb3986a6c34abaef6', //授权发起APPID
//         scene: 'log001', //发起授权场景编号
//         container: container, //渲染二维码的编号
//         sseUrl: 'https://dev.ruiziyou.com/oauth2/htapi', //授权请求地址(固定即可:后续不需要传递)
//         state: new Date().getTime().toString(), //授权状态码:如果传递在消费code的时候需要传递
//         //扫码授权成功回调
//         onSuccess: (data) => {
//             console.log(`授权成功: ${JSON.stringify(data)}`);
//         },
//         //错误回调
//         onError: (error) => {
//             console.error(`错误: ${error.message}`);
//         },
//         //扫码状态编号回调
//         onStatusChange: (data) => {
//             console.log(`授权成功: ${JSON.stringify(data)}`);
//         },
//         //二维码生成参数
//         qrCodeOptions: {
//             width: 160,
//         },
//         showStatusBar: true, //是否显示默认状态框
//     });
//     return authInstance;
// };

export default {
    name: 'login',
    components: {
        qrScanCode,
    },
    data() {
        return {
            key: '',
            jigsaw: null,
            formInline: {
                username: '', //账号
                password: '', //密码
                text: '',
                nonce: '',
                timestamp: '',
            },
            ruleInline: {
                username: [
                    {
                        required: true,
                        message: ' ',
                        trigger: 'blur',
                    },
                ],
                text: [
                    {
                        required: true,
                        message: ' ',
                        trigger: 'blur',
                    },
                ],
                password: [
                    {
                        required: true,
                        message: ' ',
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        min: 6,
                        message: '密码长度至少是6位数！',
                        trigger: 'blur',
                    },
                ],
            },
            loginMethod: '账号登录',
            scanQRCode: null,
            authPic: '',
            modalUnBindCheck: false,
            res: '',
            loginScen:this.$urlconfig.logScene || "logdev"
        };
    },
    watch: {
        async loginMethod(newVal, oldVal) {
            if (newVal == '账号登录') {
                this.getAuthPic();
            }

            this.$nextTick(() => this.switchLoginMethod(newVal));
        },
    },
    async mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.getAuthPic();
            }, 1000);
        });
        localStorage.clear();
        let key = this.hasKey();
        if (key) {
            this.key = 'test';
            // window.location.replace('/404');
            return;
        }

        // 清空本地存储 可用于用户从品牌选择页返回后初始化本地存储
        localStorage.clear();
        // 组件加载后代码延迟执行
        this.$nextTick(() => {
            // /* eslint-disable */
            let that = this;
            this.jigsaw = jigsaw.init({
                el: this.$refs.captcha,
                onSuccess() {},
                onFail: this.closefail,
                onRefresh() {},
            });
            if (this.screenWidth < 768) {
                document.getElementsByTagName('canvas')[0].removeAttribute('class', 'index_bg');
            } else {
                document.getElementsByTagName('canvas')[0].className = 'index_bg';
            }
        });
    },
    methods: {
        binding() {
            this.$router.push('/qrAuthPage?type=binding');
        },
        jumpBing() {
            localStorage.setItem('cms_token', this.res.cms_token); //设置令牌
            localStorage.setItem('username', this.res.user); //设置账号名
            this.$Message.success('登录成功!');
            localStorage.setItem('type', this.res.type); //设置用户级别
            this.$router.push('/select_stores?type=' + this.res.type);
        },
        async getAuthPic() {
            this.formInline.nonce = this.generateRandomString();
            this.formInline.timestamp = new Date().getTime();
            let res = await GetImageCaptcha({
                timestamp: this.formInline.timestamp,
                nonce: this.formInline.nonce,
            });
            this.authPic = res;
        },
        generateRandomString(length = 6, charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz') {
            let result = '';
            const charactersLength = charSet.length;
            for (let i = 0; i < length; i++) {
                result += charSet.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        /**
         * 判断是URL否有key存在
         */
        hasKey() {
            let key = this.$route.query.key;
            this.key = key;
            return !key;
        },
        handleSubmitV5() {
            // 执行验证函数
            this.$refs['ref_login'].validate(async (valid) => {
                // 验证通过发送登录请求
                if (valid) {
                    let user = this.formInline.username;
                    let pass = md5(this.formInline.password);
                    let passdata = {
                        user,
                        pass,
                        timestamp: this.formInline.timestamp,
                        nonce: this.formInline.nonce,
                        text: this.formInline.text,
                    };
                    if (this.key) {
                        passdata['key'] = this.key;
                    }
                    let res = await LoginV5(passdata);

                    if (res.errcode != 0) {
                        this.getAuthPic();
                        return;
                    }
                    res = res.data;
                    localStorage.setItem('isBindOpenId', res.isBindOpenId);
                    localStorage.setItem('cms_token', res.cms_token); //设置令牌
                    if (res.isBindOpenId) {
                        //是否已经绑定了开放平台账号 是

                        localStorage.setItem('username', res.user); //设置账号名
                        this.$Message.success('登录成功!');
                        localStorage.setItem('type', res.type); //设置用户级别
                        this.$router.push('/select_stores?type=' + res.type);
                    } else {
                        //否

                        this.res = res;

                        this.modalUnBindCheck = true;
                    }
                }
            });
        },

        // 账号登录
        handleSubmit() {
            // 执行验证函数
            this.$refs['ref_login'].validate(async (valid) => {
                // 验证通过发送登录请求
                if (valid) {
                    let user = this.formInline.username;
                    let pass = md5(this.formInline.password);
                    let passdata = {
                        user,
                        pass,
                    };
                    if (this.key) {
                        passdata['key'] = this.key;
                    }
                    let { data: res } = await login(passdata);

                    if (res.cms_token) {
                        localStorage.setItem('cms_token', res.cms_token); //设置令牌
                        localStorage.setItem('username', res.user); //设置账号名
                        this.$Message.success('登录成功!');
                        localStorage.setItem('type', res.type); //设置用户级别
                        this.$router.push('/select_stores?type=' + res.type);
                        return;
                    }
                }
            });
        },

        //切换登录模式
        switchLoginMethod(loginMethod) {
            console.log(loginMethod);
            if (loginMethod !== '扫码登录') {
                return;
            }
            return;
            const container = this.$refs.ref_qrcode;
            if (this.scanQRCode) {
                //停止接收授权信息
                this.scanQRCode.stop();
                //销毁
                this.scanQRCode.destroy();
                this.scanQRCode = null;
            }
            //创建
            this.scanQRCode = createQrCode(container);
            // 开始授权流程
            this.scanQRCode.start();
            //获取SSE连接状态
            //this.scanQRCode.getStatus();

            /**
             * 获取状态码
             * 0:授权二维码已过期
             * 1:授权成功
             * 2:已扫码未授权
             * 3:等待扫码
             * -1:拒绝授权
             */
            //this.scanQRCode.getStatusCode();
        },
        //
    },
};
</script>

<style>
/* 对话框样式 */
.ivu-modal-header {
    border-bottom: unset !important;
}

.ivu-modal-footer {
    border-top: unset !important;
}

/* 对话框样式 */
.index_bg {
    z-index: unset !important;
}

.page-account {
    display: flex;
    width: 100%;
    background-image: url('../assets/images/bg.jpg');
    background-size: cover;
    background-position: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    overflow: auto;
}

.container {
    height: 350px !important;
    padding: 0 !important;
    border-radius: 12px;
    z-index: 1;
    display: flex;
}

.containerSamll {
    /* width: 56% !important; */
    background: #fff !important;
}

.containerBig {
    width: auto !important;
    background: #fff !important;
}

.index_from {
    padding: 20px 40px 32px 40px;
    height: 400px;
    box-sizing: border-box;
}

.page-account-top {
    padding: 20px 0 !important;
    box-sizing: border-box !important;
    display: flex;
    justify-content: center;
}

.btn {
    background: linear-gradient(90deg, rgba(25, 180, 241, 1) 0%, rgba(14, 115, 232, 1) 100%) !important;
}

.captchaBox {
    width: 310px;
}

input {
    display: block;
    width: 290px;
    line-height: 40px;
    margin: 10px 0;
    padding: 0 10px;
    outline: none;
    border: 1px solid #c8cccf;
    border-radius: 4px;
    color: #6a6f77;
}

.from-wh {
    width: 400px;
}

.pwd {
    text-security: disc;
    -webkit-text-security: disc;
}
</style>
